import { Grid } from "@mui/material";
import { styled } from "@mui/material/styles";

import { SizeProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

interface Props {
  size?: SizeProp;
  color?: string;
  isPositionAbsolute?: boolean;
  customStyle?: React.CSSProperties;
}

// const Container = styled(Grid)({
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "baseline",
// });

const Container = styled(Grid, {
  shouldForwardProp: (prop) => prop !== "absolute",
})<{ absolute?: boolean }>(({ theme, absolute }) => ({
  // color: color ?? theme.palette.primary.main,
  position: "fixed",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  display: "flex",
  justifyContent: "center",
  alignItems: "baseline",

  ...(absolute && {
    position: "absolute",
    transform: "none",
  }),
}));

const StyledFontAwesomeIcon = styled(FontAwesomeIcon, {
  shouldForwardProp: (prop) => prop !== "color",
})<{ color?: string }>(({ theme, color }) => ({
  color: color ?? theme.palette.primary.main,
}));

const Spinner = ({ size = "1x", color, isPositionAbsolute = false, customStyle }: Props) => {
  return (
    <Container
      container
      absolute={isPositionAbsolute}
      style={{
        ...customStyle,
      }}
    >
      <StyledFontAwesomeIcon
        pulse
        icon={faSpinner}
        size={size}
        color={color}
      />
    </Container>
  );
};

export default Spinner;
